import { createSelector } from 'reselect';
import * as validations from '../../lib/validation.utils';
import { capitalize, filter } from 'lodash';
import { MODELS } from '../../constants/admin/settings';
import { toSelectionFormat } from '../../lib/collection.utils';
// STATE SELECTORS
const forms = state => state.admin.forms;
const modelForm = (state, props) => state.admin.forms[props.model];
const contractForm = (state, props) => state.admin.forms['contract'];
const dependencies = state => state.admin.forms.dependencies;
const isUpdateForm = (state, props) => !!props.modelId;
const model = (state, props) => ({ model: props.model, subModel: props.subModel });

export const formDataSelector = createSelector(modelForm, mf => mf);
export const isUpdateFormSelector = createSelector(isUpdateForm, isUpdate => isUpdate);
export const editedSelector = createSelector(forms, forms => forms.edited);
export const submittingSelector = createSelector(forms, forms => forms.submitting);
export const errorsSelector = createSelector(forms, forms => forms.errors);
export const fetchingSelector = createSelector(forms, forms => forms.fetching);
export const fetchedSelector = createSelector(forms, forms => forms.fetched);
export const fetchingDependenciesSelector = createSelector(forms, forms => forms.fetchingDependencies);
export const fetchingSubDependenciesSelector = createSelector(forms, forms => forms.fetchingSubDependencies);
export const fetchedDependenciesSelector = createSelector(forms, forms => forms.fetchedDependencies);
export const fetchedSubDependenciesSelector = createSelector(forms, forms => forms.fetchedSubDependencies);
export const dependenciesSelector = createSelector(forms, forms => forms.dependencies);
export const artistOptionsSelector = createSelector(dependencies, deps => toSelectionFormat(deps.artists));
export const formsIsLoadingSelector = createSelector(
    forms,
    forms => forms.fetching || forms.fetchingDependencies || forms.fetchingSubDependencies || forms.submitting
);
export const canSubmit = createSelector(
    model,
    modelForm,
    isUpdateForm,
    dependencies,
    (model, data, isUpdate, dependencies) => {
        return !!validations[`validate${capitalize(model.subModel || model.model)}`](data, isUpdate, dependencies);
    }
);
export const currentContractSelector = createSelector(contractForm, contract => {
    return contract.id;
});

// DATA SELECTORS
export const roleOptions = (roles, metadata) => {
    const allOptions = (roles || []).map(t => ({ value: t.id, label: t.name }));
    return metadata.subContext === MODELS.PARTNER
        ? filter(allOptions, o => o.label.toLowerCase() === 'user')
        : allOptions;
};
